// eslint-disable-next-line import/no-anonymous-default-export

import React, { useState, useEffect, useRef } from 'react';
import { SelectBox, CheckBox } from 'devextreme-react';
import { DateBox } from 'devextreme-react/date-box';
import DOMPurify from 'dompurify';
import TenantService from '../../api/tenant.service';
import AssetsService from '../../api/assets.service';
import moment from 'moment-timezone';
import {
  Chart,
  CommonSeriesSettings,
  Legend,
  SeriesTemplate,
  ArgumentAxis,
  ValueAxis,
  Tick,
  Size,
} from 'devextreme-react/chart';
import { CRS, latLngBounds } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapContainer, ImageOverlay, Polygon } from 'react-leaflet';
import SpacesService from 'api/spaces.service';
import DataGrid, {
  Column,
  Paging,
  FilterRow,
  HeaderFilter,
  Selection,
  FilterPanel,
} from 'devextreme-react/data-grid';

const UtilizationHeatMap = (props) => {
  const assetId = props.assetId;
  const tenant = TenantService.getTenant();
  const [selectedPeriod, setSelectedPeriod] = useState('Last 24 hours');
  const [spaces, setSpaces] = useState([]);
  const [selectedSpace2, setSelectedSpace2] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [motionBarChart, setMotionBarChart] = useState([]);
  const [bounds, setBounds] = useState(new latLngBounds([0, 0], [25, 35]));
  const [selectedSpaceItem, setSelectedSpaceItem] = useState(null);
  const [heatmapData, setHeatMapData] = useState([]);
  const [floorplanHeight, setFloorplanHeight] = useState(0);
  const [floorplanWidth, setFloorplanWidth] = useState(0);
  const [floorplan, setFloorplan] = useState('');
  const [zoom, setZoom] = useState(2);
  const [isMotion, setIsMotion] = useState(true);
  const [isStationary, setIsStationary] = useState(true);
  const [data, setData] = useState([]);
  const [utilization, setUtilization] = useState([]);
  const [timePeriod, setTimePeriod] = useState([]);
  const [totalDistance, setTotalDistance] = useState(0);


  useEffect(() => {
    const getFilters = () => {
      let filters = JSON.parse(localStorage.getItem(`${tenant}-${assetId}-util-filter`));
      console.log('filters', filters);
      // For reference, filters = [selectedPeriod, startDate, endDate, selectedSpace2]
      if (filters != null) {
        setSelectedPeriod(filters[0]);
        setStartDate(filters[1]);
        setEndDate(filters[2]);
        setSelectedSpace2(filters[3]);
      }
    };

    getFilters();
  }, [tenant, assetId]);

  useEffect(() => {
    const getSpaces = () => {
      const from = startDate;
      const to = endDate;
      console.log('from,to', from, to);
      if (from != null && to != null) {
        if (from < to) {
          AssetsService.locationHistory(assetId, from, to, null, 'asset').then((value) => {
            // @@@ add spinner here
            if (value?.data?.data?.floorplans?.length !== 0) {
              setSelectedSpace2(value?.data?.data?.floorplans[0]?.id);
            } else {
              console.log('No floorplan');
            }
            setSpaces(value?.data?.data?.floorplans);
          });
        } else {
          console.log('add toast here! End date should be after Start date');
        }
      } else {
        console.log('null!!');
      }
    };
    getSpaces();
  }, [startDate, endDate, assetId]);

  const handleStartDateChange = async (value) => {
    console.log("handleStartDateChange")
    setStartDate(value);
    setSelectedPeriod('Custom');
  };

  const handleEndDateChange = async (value) => {
    setEndDate(value);
    setSelectedPeriod('Custom');
  };

  const handlePeriodChange = async (value) => {
    if (value !== 'Custom') {
      let start, end;
      switch (value) {
        case 'Last 24 hours':
          start = moment().subtract(24, 'hours').format();
          end = moment().format();
          break;
        case 'Today':
          start = moment().startOf('day').format();
          end = moment().endOf('day').format();
          break;
        case 'Last 5 min':
          start = moment().subtract(5, 'minutes').format();
          end = moment().format();
          break;
        case 'Last 20 min':
          start = moment().subtract(20, 'minutes').format();
          end = moment().format();
          break;
        case 'Last 1 hour':
          start = moment().subtract(1, 'hour').format();
          end = moment().format();
          break;
        case 'Last 4 hours':
          start = moment().subtract(4, 'hours').format();
          end = moment().format();
          break;
        case 'Last 12 hours':
          start = moment().subtract(12, 'hours').format();
          end = moment().format();
          break;
        case 'Yesterday':
          start = moment().subtract(1, 'day').startOf('day').format();
          end = moment().subtract(1, 'day').endOf('day').format();
          break;
        case 'This Week':
          start = moment().startOf('week').format();
          end = moment().endOf('week').format();
          break;
        case 'Last Week':
          start = moment().subtract(1, 'weeks').startOf('week').format();
          end = moment().subtract(1, 'weeks').endOf('week').format();
          break;
        case 'This Month':
          start = moment().startOf('month').format();
          end = moment().endOf('month').format();
          break;
        case 'Last Month':
          start = moment().subtract(1, 'month').startOf('month').format();
          end = moment().subtract(1, 'month').endOf('month').format();
          break;
        case 'Last 7 days':
          start = moment().subtract(7, 'days').format();
          end = moment().format();
          break;
        default:
          break;
      }
      console.log('start: ', start, ',end: ', end);
      setStartDate(start);
      setEndDate(end);
      setSelectedPeriod(value);
    }
  };

  function submitOk() {
    if (endDate > startDate) {
      let filters = [selectedPeriod, startDate, endDate, selectedSpace2];
      localStorage.setItem(`${tenant}-${assetId}-util-filter`, JSON.stringify(filters));
      console.log('filtersok', filters);
      getAssetUtilizationChart();
      getFloorPlans();
    } else {
      console.log('add toast here! End date should be after Start date');
    }
  }

  const getAssetUtilizationChart = async () => {
    // setMotionBarChart([])
    const from = startDate;
    const to = endDate;
    if (selectedSpace2 === null) return null; // if nothing is selected from floorplans
    // if (!isStationary && !isMotion) return null;
    // setHeight('100%');
    await AssetsService.getAssetUtilizationChart(
      props.assetId,
      selectedSpace2,
      from,
      to,
      true,
      false
      // isMotion,
      // isStationary
    ).then(async (result) => {
      if (result.data.status === 200) {
        const response = result.data.data;
        await response.timeGraphData.forEach(function (result) {
          result.start = new Date(result.start);
          result.end = new Date(result.end);
        });
        setMotionBarChart(response.timeGraphData);
        setUtilization(calculateUtilization(response.timeGraphData));
        setTimePeriod((new Date(to) - new Date(from)) / (1000 * 60)); // minutes
        const utilizationPercent = (utilization / timePeriod) * 100;
        console.log('utilization', utilization);
        console.log('diff', timePeriod);
        console.log('utilizationPercent', utilizationPercent);
      } else {
        // setLoadingText('No Data')
      }
    });
  };

  function calculateUtilization(data) {
    let totalMs = 0;

    Object.values(data).forEach((item) => {
      if (item.action === 'Motion' && item.start && item.end) {
        const start = new Date(item.start);
        const end = new Date(item.end);

        const diff = end - start; // milliseconds
        if (diff > 0) {
          totalMs += diff;
        }
      }
    });

    return totalMs / (1000 * 60); // minutes
  }

  const customizeSeries = (deviceMotion) => {
    if (deviceMotion === 'Motion') {
      return { color: '#FFC001' };
    }
    return { color: '#CCCCCC' };
  };

  const customizeTextLegend = (item) => {
    // return item.seriesName === 'noMotion' ? 'No Motion' : item.seriesName;
    return item.seriesName === 'noMotion' ? 'No Utilization' : 'Utilization';
  };

  const cellSize = 1; // in meters

  const bands = [
    { max: 1 / 60, color: '#BA8DC1' }, // 0-1 min
    { max: 5 / 60, color: '#99D5FF' },
    { max: 15 / 60, color: '#79DE85' },
    { max: 1, color: '#FFFF00' },
    { max: 6, color: '#FEB800' },
    { max: 24, color: '#FF0000' },
  ];

  function getColorFromBand(hoursPerDay) {
    for (let band of bands) {
      if (hoursPerDay <= band.max) return band.color;
    }
    return 'red';
  }

  function normalizeHeatmapData(rawData, totalDays) {
    if (!Array.isArray(rawData) || rawData.length === 0) {
      return [];
    }
    const grid = {};
    rawData.forEach(({ lat, lng, value }) => {
      const x = Math.floor(lng);
      const y = Math.floor(lat);
      const key = `${x},${y}`;
      grid[key] = (grid[key] || 0) + value;
    });

    return Object.entries(grid).map(([key, totalSeconds]) => {
      const [x, y] = key.split(',').map(Number);
      const hoursPerDay = totalSeconds / 3600 / totalDays;
      return { x, y, color: getColorFromBand(hoursPerDay) };
    });
  }

  const legendBoxStyle = (bgColor) => ({
    backgroundColor: bgColor,
    padding: '6px 10px',
    width: '100px',
    color: '#000',
    fontSize: '12px',
    textAlign: 'center',
    borderRadius: '4px',
  });

  const getFloorPlans = async () => {
    // resetData()
    const from = startDate;
    const to = endDate;
    if (from === 'Invalid date' || to === 'Invalid date') return true;
    AssetsService.locationHistory(props.assetId, from, to).then((response) => {
      if (response?.data?.data?.floorplans?.length > 0) {
        console.log('response.data.data', response.data.data);
        setSelectedSpaceItem(response.data.data.floorplans[0].id);
        // setSelectedSpaceItemName(response.data.data.floorplans[0].name);
        // setSpaces(response.data.data.floorplans);
        getAssetUtilizationHeatMap(selectedSpaceItem);
        getAssetUtilizationDataGrid(selectedSpaceItem);
        // getAssetUtilizationChart(selectedSpaceItem)
      } else {
        // setSelectedSpaceItem(null);
        // setSelectedSpaceItemName(null);
        // setSpaces([]);
        // setLoadingText("No Data")
        // setMotionBarChart([])
        // setData([])
        // setHeatMapData([])
        // setTotalDistance(0)
        // setFloorplan(null)
        // setHeatmapLoading(false);
      }
    });
  };

  const getAssetUtilizationHeatMap = async () => {
    try {
      // setHeatmapLoading(true);
      // setLoadingText('Loading...')
      // setHeatMapData([])
      // setFloorplan(null)

      // if (selectedSpaceItem === null) {
      //   setHeatmapLoading(false);
      //   return null;
      // }

      // if (!isStationary && !isMotion) {
      //   setHeatmapLoading(false);
      //   return null;
      // }

      const from = startDate;
      const to = endDate;

      // if (selectedSpaceItem === null) return null; // if nothing is selected from floorplans
      // if (!isStationary && !isMotion) return null;

      // setHeight('100%');

      // console.log("from",from)
      // console.log("to",to)

      const result = await AssetsService.getAssetUtilizationHeatMap(
        props.assetId,
        selectedSpaceItem,
        from,
        to,
        true,
        false
      );

      if (result.data.status === 200) {
        const response = result.data.data;
        // setUtilizationText(secondsToText(response.totalDurationInSeconds))
        // setUnitValue(response.unit)
        setHeatMapData(response.mapData);
        // setMax(response.maxValue);
        if (response.mapData.length > 0) {
          // setHeight('100%');

          // Load floorplan
          try {
            const res = await SpacesService.getSpaceFloorplan(selectedSpaceItem);
            let myFloorplan = URL.createObjectURL(res?.data);
            setFloorplan(myFloorplan);
          } catch (error) {
            console.error('Error loading floorplan:', error);
          }
          // setting zoom
          // if (listRef && listRef.current){
          //   let s = listRef.current.clientWidth
          //   if (listRef.current.clientHeight < s) {
          //       s = listRef.current.clientHeight
          //   }
          //   let z = (Math.log(s / 15.625) / Math.log(2)) - 1.5
          //   setZoom(z)
          // }

          // Get space bounds
          try {
            const res2 = await SpacesService.getSpace(selectedSpaceItem);
            let response2 = res2.data;
            let refSpaceBounds = response2.data.localCoordinates;
            let correctedRefSpaceBounds = [];
            for (let i = 0; i < refSpaceBounds.length; i++) {
              correctedRefSpaceBounds.push([refSpaceBounds[i][1], refSpaceBounds[i][0]]);
            }
            let coords = correctedRefSpaceBounds;
            let xMax = 0;
            let yMax = 0;
            for (let i = 0; i < coords.length; i++) {
              if (coords[i][0] > xMax) {
                xMax = coords[i][0];
              }
              if (coords[i][1] > yMax) {
                yMax = coords[i][1];
              }
            }
            console.log('X-MAX', xMax);
            console.log('Y-MAX', yMax);
            setFloorplanWidth(xMax);
            setFloorplanHeight(yMax);
            setBounds(new latLngBounds([0, 0], [xMax, yMax]));
            // setCenter([0 + xMax / 2, 0 + yMax / 2])
          } catch (error) {
            console.error('Error loading space bounds:', error);
          }

          // const duration = moment.duration(moment(to).diff(from));
          // const diff = duration.asSeconds();
          // const utilizationPercentage = Math.round(((response.totalDurationInSeconds / diff) * 100));
          // console.log("utilizationPercentage",utilizationPercentage)
          // console.log("diff",diff)
          // console.log("response.totalDurationInSeconds",response.totalDurationInSeconds)
          // setUtilizationPercent(utilizationPercentage);
        } else {
          // setLoadingText('No Data')
        }
      }
    } catch (error) {
      console.error('Error loading heat map:', error);
      // setHeatMapData([]);
      // setFloorplan(null);
      // setLoadingText('Error loading data');
      // setHeatmapError(`Failed to load heat map: ${error.message}`);
      // setRetryCount(prev => prev + 1);
    } finally {
      // setHeatmapLoading(false);
    }
  };

  function HeatmapGridOverlay({ floorplanUrl, rawData, startDate, endDate }) {
    // const bounds = [[0, 0], [xMax, floorplanWidth]];
    const totalDays = (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24);

    const normalizedGrid = normalizeHeatmapData(rawData, totalDays);

    return (
      <>
        <MapContainer
          id="map"
          // crs={L.CRS.Simple}
          crs={CRS.Simple}
          bounds={bounds}
          style={{ height: '500px', width: '100%' }}
          maxZoom={7}
          zoomSnap={0}
          zoomControl={true}
        >
          {/* {heatmapLoading && (
            <div className="noDataHeatMap">
              <p>Loading...</p>
            </div>
          )} */}
          {/* {!heatmapLoading && !heatmapError && heatmapData.length === 0 && (
            <div className="noDataHeatMap">
              <p>{loadingText}</p>
            </div>
          )} */}
          {floorplan && <ImageOverlay url={floorplanUrl} bounds={bounds} opacity={1} />}

          {normalizedGrid.map(({ x, y, color }, idx) => {
            const w = x === Math.floor(floorplanWidth) ? floorplanWidth - x : 1;
            const h = y === Math.floor(floorplanHeight) ? floorplanHeight - y : 1;

            return (
              <Polygon
                key={idx}
                positions={[
                  [y, x],
                  [y, x + w],
                  [y + h, x + w],
                  [y + h, x],
                ]}
                pathOptions={{ fillColor: color, fillOpacity: 0.8, stroke: false }}
              />
            );
          })}
          <div
            style={{
              position: 'absolute',
              bottom: '20px',
              right: '20px',
              zIndex: 1000,
              backgroundColor: 'white',
              borderRadius: '4px',
              opacity: 0.9,
            }}
          >
            {heatmapData.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '10px',
                  right: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  zIndex: 1000,
                  backgroundColor: 'white',
                  padding: '8px',
                  borderRadius: '6px',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  height: 'fit-content',
                }}
              >
                {/* Vertical Label */}
                <div
                  style={{
                    writingMode: 'vertical-rl',
                    transform: 'rotate(180deg)',
                    fontWeight: '600',
                    fontSize: '12px',
                    textAlign: 'center',
                    marginRight: '10px',
                    lineHeight: '1.2',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Average Utilization per Day
                </div>

                {/* Color Legend Bars */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <div style={legendBoxStyle('#BA8DC1')}>0 - 1 min</div>
                  <div style={legendBoxStyle('#99D5FF')}>1 - 5 min</div>
                  <div style={legendBoxStyle('#79DE85')}>5 - 15 min</div>
                  <div style={legendBoxStyle('#FFFF00')}>15 - 60 min</div>
                  <div style={legendBoxStyle('#FEB800')}>1 - 6 hours</div>
                  <div style={legendBoxStyle('#FF0000')}>6 - 24 hours</div>
                </div>
              </div>
            )}
          </div>
        </MapContainer>
      </>
    );
  }

  const OnMotionChange = async (motion) => {
    if (motion === 'isMotion') {
      setIsMotion(!isMotion);
    } else if (motion === 'isStationary') {
      setIsStationary(!isStationary);
    }
  };

  const getAssetUtilizationDataGrid = async () => {
    // setData([]);
    setTotalDistance(0);
    const from = startDate
    const to = endDate
    if (selectedSpaceItem === null) return null; // if nothing is selected from floorplans
    if (!isStationary && !isMotion) return null;
    // setHeight('100%');
    await AssetsService.locationHistory(props.assetId, from, to, selectedSpaceItem).then(
      (value) => {
        if (value.data.status === 200) {
          setData(value.data.data.history);
          setTotalDistance(value.data.data.totalDistance);
        } else {
          // setLoadingText('No Data');
        }
      }
    );
  };

  return (
    <div style={{ margin: '10px' }}>
      <div className="btnContainer">
        <div className="dateBtn">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SelectBox
              style={{ marginRight: '10px', width: '20%' }}
              dataSource={[
                'Today',
                'Last 5 min',
                'Last 20 min',
                'Last 1 hour',
                'Last 4 hours',
                'Last 12 hours',
                'Last 24 hours',
                'Yesterday',
                'This Week',
                'Last Week',
                'This Month',
                'Last Month',
                'Last 7 days',
                'Custom',
              ]}
              value={selectedPeriod}
              onValueChanged={(e) => handlePeriodChange(e.value)}
              labelMode="static"
              label="Period"
              stylingMode="outlined"
            />
            {/* <div onClick={() => handleStartDate()} > */}
            <DateBox
              // ref={dateBoxRefStart}
              style={{ marginRight: '10px' }}
              type="datetime"
              value={startDate}
              onValueChanged={async (e) => await handleStartDateChange(e.value)}
              placeholder="Start Date"
              labelMode="static"
              label="Start Date"
              stylingMode="outlined"
              displayFormat="yyyy-MM-dd HH:mm"
              valueFormat="yyyy-MM-dd HH:mm"
            />
            {/* </div> */}
            {/* <div onClick={() => handleEndDate()}> */}
            <DateBox
              // ref={dateBoxRefEnd}
              style={{ marginRight: '10px' }}
              type="datetime"
              value={endDate}
              onValueChanged={async (e) => await handleEndDateChange(e.value)}
              placeholder="End Date"
              labelMode="static"
              label="End Date"
              stylingMode="outlined"
              displayFormat="yyyy-MM-dd HH:mm"
              valueFormat="yyyy-MM-dd HH:mm"
            />
            {/* </div> */}
            <SelectBox
              style={{ marginRight: '10px' }}
              labelMode="static"
              label="Floorplan"
              items={spaces}
              stylingMode="outlined"
              value={selectedSpace2}
              // onValueChanged={onFloorplanValueChanged}
              valueExpr="id"
              displayExpr="name"
            ></SelectBox>
            <div className="save-btn" onClick={submitOk}>
              OK
            </div>
            <div className="uploadBtnMechanicalReport">
              <button id="generatePdfButton" alt="Export Data" title="Export Data" type="button">
                <img
                  src="../icons/excelNew.svg"
                  alt="Export Data"
                  style={{ height: '24px', width: '24px' }}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='utilizationTextCheckbox'>
        <p>
        Asset Utilization is 
        <b> {((utilization/timePeriod)*100).toFixed(3)}% </b>
        over 
        <b> {Math.round(timePeriod)} minutes </b>
        and it travelled 
        <b> {totalDistance} meters</b>
        </p>      
      </div>
      <div style={{ width: '70%', marginTop: '30px', marginBottom: '30px' }}>
        {motionBarChart.length ? (
          <Chart
            animation={{ enabled: false }}
            dataSource={motionBarChart}
            barGroupPadding={0.2}
            rotated={true}
          >
            <Size width={'100%'} height={150} />
            <ArgumentAxis
              categories={['Device Motion']}
              label={{
                customizeText: (arg) => {
                  return '';
                },
              }}
            >
              <Tick visible={false} />
            </ArgumentAxis>
            <ValueAxis
              label={{
                customizeText: (arg) => {
                  return moment(arg.value).format('YYYY-MM-DD HH:mm');
                },
              }}
            />
            <CommonSeriesSettings
              type="rangeBar"
              argumentField="activity"
              rangeValue1Field="start"
              rangeValue2Field="end"
              barOverlapGroup="activity"
            ></CommonSeriesSettings>
            <Legend
              verticalAlignment="center"
              horizontalAlignment="left"
              customizeText={customizeTextLegend}
            />
            <SeriesTemplate nameField="action" customizeSeries={customizeSeries} />
          </Chart>
        ) : (
          ''
        )}
      </div>
      <>
        <HeatmapGridOverlay
          floorplanUrl={floorplan}
          rawData={heatmapData}
          startDate={startDate}
          endDate={endDate}
        />
      </>
      <>
              {heatmapData.length > 0 && (
                <div className="utilizationCheckbox">
                  <CheckBox
                    value={isMotion}
                    text="Motion time"
                    hint="Motion"
                    iconSize="15"
                    onValueChanged={() => OnMotionChange('isMotion')}
                  />
                  <div style={{ paddingTop: '10px' }}></div>
                  <CheckBox
                    value={isStationary}
                    text="No motion time"
                    hint="Stationary"
                    iconSize="15"
                    onValueChanged={() => OnMotionChange('isStationary')}
                  />
                  <div
                    style={{
                      // display: showMotionStationaryErrorMsg ? 'block' : 'none',
                      color: '#d71109',
                    }}
                  >
                    <p>Check either or both boxes to see Utilization data</p>
                  </div>
                </div>
              )}

              <div style={{ paddingTop: '50px' }}>
                <DataGrid
                  height={'calc(100vh - 329px)'}
                  dataSource={data}
                  // ref={dropDataGridUtilRef}
                  columnAutoWidth={true}
                  allowColumnResizing={true}
                  showBorders={true}
                  // noDataText={loadingText}
                  keyExpr="id"
                >
                  <Selection mode="multiple" showCheckBoxesMode="none" />
                  <FilterPanel
                    visible={true}
                    texts={{ createFilter: '', clearFilter: 'Clear Filter', filterEnabledHint: '' }}
                  />
                  <Paging enabled={false} />
                  <FilterRow visible="true" apply-filter="true" />
                  <HeaderFilter visible="showHeaderFilter" />
                  <Column
                    allowSorting={true}
                    dataField={DOMPurify.sanitize('time')}
                    caption={'Date'}
                    dataType="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    allowFiltering={false}
                    defaultSortIndex={1}
                    defaultSortOrder="desc"
                  ></Column>
                  <Column
                    dataField={DOMPurify.sanitize('space.name')}
                    caption={'Space'}
                    dataType="string"
                    alignment={'left'}
                  ></Column>
                  <Column
                    dataField={DOMPurify.sanitize('motion')}
                    caption={'Event'}
                    dataType="string"
                    alignment={'left'}
                  ></Column>
                  <Column
                    dataField={DOMPurify.sanitize('distance')}
                    caption={'Distance [m]'}
                    dataType="number"
                    alignment={'left'}
                  ></Column>
                </DataGrid>
              </div>
            </>
    </div>
  );
};
export default UtilizationHeatMap;
